import { render, staticRenderFns } from "./ProductSendbill.vue?vue&type=template&id=4c4251a1&scoped=true&"
import script from "./ProductSendbill.vue?vue&type=script&lang=js&"
export * from "./ProductSendbill.vue?vue&type=script&lang=js&"
import style0 from "./ProductSendbill.vue?vue&type=style&index=0&id=4c4251a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4251a1",
  null
  
)

export default component.exports